import React, { useState } from "react";
import { FiPhoneCall, FiMail, FiHome } from "react-icons/fi";

const Contact = () => {

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: ""
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const text = `Hello,
Name: ${form.firstName} ${form.lastName}
Email: ${form.email}
Phone: ${form.phone}
Message: ${form.message}`;

    const url = `https://wa.me/919136271336?text=${encodeURIComponent(text)}`;

    window.open(url, "_blank");
  };

  return (
<>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title">Contact Us</h2>
          </div>
        </div>
      </div>
    </div>


    <div className="section-full p-t150 p-b120 site-bg-white twm-contact-section-wrap">
      <div className="container">

        <div className="section-content">
          <div className="twm-contact-section">
            <div className="row">

              {/* Title */}
              <div className="col-12 text-center mb-5">
                <div className="twm-maskingtext">
                  <h1>Get In Touch</h1>
                  <img src="images/text-masking-pic.jpg" alt="Image" />
                </div>
              </div>

              {/* Contact Info */}
              <div className="col-12">
                <div className="twm-get-info-wrap">
                  <div className="row">

                    {/* Phone */}
                    <div className="col-12 col-md-4">
                      <div className="twm-get-info text-center">
                        <div className="twm-media mb-3">
                          <FiPhoneCall size={35} />
                        </div>
                        <div className="twm-content">
                          <p>Phone</p>
                          <h3 className="twm-title">
                            <a href="tel:+919136271336">
                              +91 9136271336
                            </a>
                          </h3>
                        </div>
                      </div>
                    </div>

                    {/* Email */}
                    <div className="col-12 col-md-4">
                      <div className="twm-get-info text-center">
                        <div className="twm-media mb-3">
                          <FiMail size={35} />
                        </div>
                        <div className="twm-content">
                          <p>Email</p>
                          <h3 className="twm-title">
                            booking@velocitycabs.com
                          </h3>
                        </div>
                      </div>
                    </div>

                    {/* Address */}
                    <div className="col-12 col-md-4">
                      <div className="twm-get-info text-center">
                        <div className="twm-media mb-3">
                          <FiHome size={35} />
                        </div>
                        <div className="twm-content">
                          <p>Address</p>
                          <h6>Velocity Cab</h6>
                          <h3 className="twm-title">
                            Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
                          </h3>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

          

            </div>
          </div>
        </div>

      </div>
    </div>

</>
  );
};

export default Contact;